import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "customersFeedbackBlock" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('customersFeedback')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (el, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "comment"
          }, [
            (el.type !== 'notRated')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: 
              require(`@/assets/icons/${_ctx.getLabel(el.type)[el.type]}Pressed.png`)
            ,
                  alt: ""
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(el.value), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}